import { render, staticRenderFns } from "./repair.vue?vue&type=template&id=6312728c&scoped=true&"
import script from "./repair.vue?vue&type=script&lang=js&"
export * from "./repair.vue?vue&type=script&lang=js&"
import style0 from "./repair.vue?vue&type=style&index=0&id=6312728c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6312728c",
  null
  
)

export default component.exports